'use strict';

function service($q, $location, $resource) {
    return function (params, time, body) {
        var deferred = $q.defer();
        function excludeTime(obj, doIt) {
            var newObj = {};
            if (doIt) {
                for (var i in obj) {
                    if ((i != 'start') && (i != 'end')) {
                        newObj[i] = obj[i];
                    }
                }
                return newObj;
            } else {
                return obj;
            }
        }
        // TODO - ADD viz.GETparams to time if exists
        var Rest, timeParam = {}, searchParams = {};
        if (time) { timeParam = time }

        // remove start and end from location if time param exists (and if time is already defined) - i.e. requery
        if ((time) && (typeof $location.$$search.start !== 'undefined') && (typeof $location.$$search.end !== 'undefined')) {
            searchParams = angular.copy(excludeTime($location.$$search, true));
        } else {
            searchParams = angular.copy(excludeTime($location.$$search, false));
        }
        if (body) {
            for (var p in body) {
                searchParams[p] = body[p];
            }
        }
        if (params.key) {
            // if the result is a piece of an object..
            Rest = $resource(api+params.get, timeParam, {
                query: { method: 'GET', params: searchParams, isArray: false }
            })
            Rest.query(function (data) {
                return deferred.resolve(data[params.key]);
            })
        }
        // else if (params.sql) {
        //     //if the result is an array
        //     Rest = $resource(params.get, timeParam, {
        //         query: { method: 'GET', params: searchParams, isArray: true }
        //     });
        //     Rest.query(function (data) {
        //         return deferred.resolve(data);
        //     })
        // }
        else {
            // if the result is an array
            Rest = $resource(api+params.get, timeParam, {
                query: { method: 'GET', params: searchParams, isArray: true }
            });
            Rest.query(function (data) {
                return deferred.resolve(data);
            })
        }
        return deferred.promise;
    }
}

service.$inject = ['$q', '$location', '$resource'];
module.exports = service;


/** WEBPACK FOOTER **
 ** ./src/pages/services/getdata.js
 **/